module.exports = __webpack_public_path__ + "static/media/nt3.704e65f5.png";